module.exports = __webpack_public_path__ + "assets/img/23.d980d064.png";